<template>
  <div @contextmenu="selectComponentDEV($event, schema.model)" :class="[getSelectedDEV && 'dev-selected-component']">
    <Pivot ref="pivot" v-bind="schema.attributes" :report="value" :global="global" :componentFolder="'node_modules/flexmonster/'"></Pivot>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import { Pivot } from 'vue-flexmonster';
import devComponentMixin from '@/mixins/dev-component-mixin';

export default {
  mixins: [abstractField, devComponentMixin],

  components: {
    Pivot
  },

  data() {
    return {
      global: {
        localization: this.jsonData()
      }
    };
  },

  created() {
    if (this.value) {
      this.value = JSON.parse(this.value);
    }
  },

  mounted() {
    const { theme } = this.schema.attributes;

    if (theme) {
      import(`flexmonster/theme/${theme}/flexmonster.min.css`);
    }
  },

  methods: {
    jsonData() {
      return {
        fieldsList: {
          flatHierarchyBox: 'Selecionar e organizar colunas',
          hierarchyBox: 'Selecione os campos',
          filterBox: 'Filtros',
          rowBox: 'Campos da Linha',
          columnBox: 'Campos da Coluna',
          measureBox: 'Valores',
          values: 'Valores',
          addCalculatedMeasure: 'Adicionar valor calculado',
          expandAll: '+ Expandir Tudo',
          collapseAll: '- Recolher Tudo',
          formulasGroupName: 'Valores calculados',
          allFields: 'Todos os campos',
          rows: 'Linhas',
          columns: 'Colunas',
          filters: 'Filtros',
          dropField: 'Abaixe o campo aqui',
          title: 'Campos',
          subtitle: 'Arraste e solte os campos para organizar'
        },
        filter: {
          all: 'Tudo',
          multipleItems: 'Múltiplos Itens',
          selectAll: 'Selecionar tudo',
          selectAllResults: 'Selecionar todos os resultados',
          top: 'Início',
          bottom: 'Fim',
          ascSort: 'Az',
          descSort: 'zA',
          measuresPrompt: 'Selecione um campo',
          search: 'Pesquisar',
          amountSelected: '{0} de {1} selecionados',
          amountFound: '{0} de {1} encontrados são selecionados',
          sort: 'Ordenar:',
          filterBy: 'Filtrar por:',
          labelsFilter: 'Rótulos',
          numbersFilter: 'Rótulos',
          valuesFilter: 'Valores',
          datesFilter: 'Datas',
          timeFilter: 'Tempo',
          equal: 'Igual',
          notEqual: 'Não igual',
          before: 'Antes',
          beforeEqual: 'Antes ou igual',
          after: 'Depois de',
          afterEqual: 'Depois ou igual',
          between: 'Entre',
          notBetween: 'Não entre',
          last: 'Última...',
          current: 'Atual...',
          next: 'Próxima...',
          begin: 'Início',
          notBegin: 'Não começar',
          end: 'Fim',
          notEnd: 'Não terminar',
          contain: 'Conter',
          notContain: 'Não contém',
          greater: 'Maior',
          greaterEqual: 'Maior ou igual',
          less: 'Menos',
          lessEqual: 'Menor ou igual',
          day: 'Dia',
          week: 'Semana',
          month: 'Mês',
          quarter: 'Trimestre',
          year: 'Ano',
          seconds: 'seg.',
          minutes: 'min.',
          hours: 'hr.',
          days: 'd.',
          clearDateFilter: 'Limpar filtro de data',
          clearLabelFilter: 'Limpar o filtro de etiquetas',
          clearNumberFilter: 'Limpar o filtro de etiquetas',
          clearTimeFilter: 'Limpar o filtro de tempo',
          clearValueFilter: 'Limpar filtro de valor'
        },
        drillThrough: {
          title: 'Detalhes',
          row: 'Linha: {0}',
          column: 'Coluna: {0}',
          value: '{0}: {1}'
        },
        calculatedView: {
          title: 'Valor calculado',
          measureBox: 'Arraste campos para a Fórmula',
          measureName: 'Nome do Campo',
          formula: 'Fórmula',
          formulaPrompt: 'Abaixe os valores e edite a fórmula aqui',
          calculateIndividualValues: 'Calcular valores individuais',
          removeValue: 'Remover',
          removeValueTitle: 'Remover {0}?',
          removeValueMessage: 'Tem certeza de que deseja remover esse valor calculado?',
          header: 'Adicionar valor calculado',
          allValues: 'Todos os valores'
        },
        grid: {
          total: 'Total',
          totals: 'Totais',
          grandTotal: 'Total geral',
          blankMember: '(blank)',
          dateInvalidCaption: 'Data inválida',
          reportInformation: 'Report Information'
        },
        charts: {
          showLegend: 'Mostrar Legenda',
          hideLegend: 'Esconder Legenda',
          selectMeasures: 'Selecione medidas',
          rowNumber: 'Número da linha',
          flatTypesLimitation: 'Os gráficos de barras e linhas de barras não estão disponíveis para a tabela plana.',
          noDataTitle: 'Nenhum dado a ser exibido.',
          noMeasuresTitle: 'Nenhuma valores para exibir. Adicione pelo menos uma valor na lista de campos.',
          bigDataSetWarning:
            'O conjunto de dados é muito grande para ser exibido no gráfico. O conjunto de dados será cortado na quantidade ajustada no gráfico.'
        },
        tooltips: {
          fieldList: 'Clique para abrir сampos',
          selectAggregation: 'Selecione agregação',
          editCalculatedMeasure: 'Editar valor calculado',
          row: 'Linha:',
          column: 'Coluna:',
          headerResize: 'Arraste para redimensionar',
          headerFit: 'Dê um duplo clique para ajustar',
          filterIcon: 'Clique para filtrar',
          filtered: 'Filtrado',
          expandIcon: 'Clique para ampliar',
          collapseIcon: 'Clique para fechar',
          drillDown: 'Clique para detalhar',
          drillUp: 'Clique para perfurar',
          sortIcon: 'Click para ordernar por ordem decrescente',
          sortedDescIcon: 'Click para ordernar por ordem crescente',
          sortedAscIcon: 'Click para ordernar por ordem decrescente',
          close: 'Clique para fechar'
        },
        aggregations: {
          sum: {
            caption: 'Soma',
            totalCaption: 'Soma de {0}',
            grandTotalCaption: 'Soma total de {0}'
          },
          count: {
            caption: 'Contagem',
            totalCaption: 'Contagem de {0}',
            grandTotalCaption: 'Contagem total de {0}'
          },
          distinctCount: {
            caption: 'Contagem Distinta',
            totalCaption: 'Contagem distinta de {0}',
            grandTotalCaption: 'Total Contagem distinta de {0}'
          },
          difference: {
            caption: 'Diferença',
            totalCaption: 'Diferença de {0}',
            grandTotalCaption: 'Diferença total de {0}'
          },
          percentDifference: {
            caption: 'Por cento de Diferença',
            totalCaption: 'Por cento de Diferença {0}',
            grandTotalCaption: 'Porcentagem total de Diferença {0}'
          },
          average: {
            caption: 'Média',
            totalCaption: 'Média de {0}',
            grandTotalCaption: 'Média total de {0}'
          },
          median: {
            caption: 'Mediana',
            totalCaption: 'Mediana de {0}',
            grandTotalCaption: 'Mediana total de {0}'
          },
          stdevp: {
            caption: 'População StDev',
            totalCaption: 'População StDev de {0}',
            grandTotalCaption: 'População StDev total de {0}'
          },
          stdevs: {
            caption: 'Amostra StDev ',
            totalCaption: 'Amostra StDev de {0}',
            grandTotalCaption: 'Amostra StDev total de {0}'
          },
          product: {
            caption: 'Produto',
            totalCaption: 'Produto de {0}',
            grandTotalCaption: 'Produto total de {0}'
          },
          min: {
            caption: 'Mínimo',
            totalCaption: 'Mínimo de {0}',
            grandTotalCaption: 'Mínimo total de {0}'
          },
          max: {
            caption: 'Máximo',
            totalCaption: 'Máximo de {0}',
            grandTotalCaption: 'Máximo total de {0}'
          },
          percent: {
            caption: 'Por cento',
            totalCaption: 'Por cento de {0}',
            grandTotalCaption: 'Porcentagem total de {0}'
          },
          percentOfColumn: {
            caption: 'Por cento de Coluna',
            totalCaption: 'Por cento de Coluna {0}',
            grandTotalCaption: 'Porcentagem total de Coluna {0}'
          },
          percentOfRow: {
            caption: '% de Linha',
            totalCaption: '% de Linha de {0}',
            grandTotalCaption: '% Total da linha de {0}'
          },
          percentOfParentRowTotal: {
            caption: '% de Linha Pai',
            totalCaption: '%  de Linha Pai de {0}',
            grandTotalCaption: '%  de Linha Pai de {0}'
          },
          percentOfParentColumnTotal: {
            caption: '% de Coluna Pai',
            totalCaption: '% de Coluna Pai de {0}',
            grandTotalCaption: '% de Coluna Pai de {0}'
          },
          runningTotals: {
            caption: 'Totais em execução',
            totalCaption: 'Totais em execução de {0}',
            grandTotalCaption: 'Totais em execução de {0}'
          },
          index: {
            caption: 'Índice',
            totalCaption: 'Índice de {0}',
            grandTotalCaption: 'Índice de {0}'
          },
          none: {
            caption: 'Sem cálculos'
          }
        },
        messages: {
          error: 'Erro!',
          warning: 'Aviso',
          limitation: 'Limitation!',
          browse: 'Procurar',
          confirmation: 'Confirmação',
          reportFileType: 'Flexmonster report file',
          loading: 'Carregando...',
          loadingConfiguration: 'Carregando configuração...',
          loadingData: 'Carregando dados...',
          waiting: '{0} seg',
          progress: '{0} linhas',
          progressKnown: 'carregado {0} KB de {1} KB',
          progressUnknown: 'carregado {0} КB',
          sortingMembers: 'Membros de classificação...',
          analyzing: 'Analisando os dados...',
          analyzingProgress: '{0} registros de {1} ({2}%)',
          analyzingRecords: '{0}% records',
          saving: 'Saving...',
          loadingDimensions: 'Carregando dimensões...',
          loadingHierarchies: 'Carregando hierarquias...',
          loadingMeasures: 'Carregando medidas...',
          loadingKPIs: 'Carregando KPIs...',
          loadingMembers: 'Carregando membros...',
          loadingLevels: 'Carregando níveis...',
          loadingProperties: 'Carregando propriedades...',
          fullscreen: 'Abrir tabela dinâmica em tela cheia?',
          exportComplete: 'Exportação de dados é criado, por favor, clique em "Salvar" para salvar os dados.',
          exportProgress: 'Exportação em andamento...',
          exportError: 'Falha ao exportar. Um erro inesperado ocorreu.',
          generatingPDF: 'Gerando PDF',
          pleaseWait: 'Por favor, aguarde.',
          pagesWereGenerated: 'páginas foram geradas.',
          uploading: 'Enviando para o servidor...',
          cantSaveFile: 'Erro: Não é possível salvar o arquivo.',
          cantSaveToClipboard: 'Erro: Não é possível escrever para o clipboard.',
          saveReportToFile: 'O relatório está pronto para ser salvo no arquivo. Clique no botão "Salvar" para salvar o relatório.',
          loadReportFromFile: 'Selecionar arquivo de relatório a ser carregado',
          inputNewName: 'Entrada de novo nome',
          inputReportName: 'Por favor, insira o nome do relatório.',
          invalidDataSource:
            "Fonte de dados ou catálogo inválido. Por favor, verifique. <br/><br/><a href='https://www.flexmonster.com/doc/typical-errors/#invalid-datasource' target='_blank'>Leia mais informações sobre este erro</a></u>",
          dataStreamError: 'Erro de transmissão. {0}',
          unableToOpenFile:
            "Impossível abrir o ficheiro {0}.<br/><br/>Parece que este arquivo não existe ou'Access-Control-Allow-Origin'o cabeçalho está ausente no recurso solicitado.",
          errorTextMessage: "</br>Detalhes: '{0}'",
          unableTwoFileBrowsingSessions: 'A caixa de diálogo Procurar arquivo já está aberta.',
          inappropriateFileFormat: 'O arquivo de dados é de formato inadequado.',
          invalidJSONdata: 'Os dados JSON são inválidos.',
          wrongFormulaFormat: 'Formato de fórmula errado. Por favor, verifique.',
          wrongUniqueName: "O campo com <b>'{0}'</b> uniqueName não está definido.",
          excelCsvChartsExportError: 'Exportar para o Microsoft Excel ou CSV não está disponível para gráficos.',
          excelPdfExportLimitation: 'Exportar para o Microsoft Excel ou PDF não está disponível na edição atual.',
          excelExportLimitation: 'Exportar não está disponível na edição atual.',
          noDataAvailable: 'A fonte de dados está vazia. Por favor, verifique o arquivo CSV.',
          saveDataToFile: 'Os dados estão prontos para serem salvos no arquivo, clique no botão "Salvar" para salvar o arquivo.',
          dataWasUpdated: 'A fonte de dados foi atualizada no servidor. Atualizar o relatório?',
          cantConnectToAccelerator:
            'Não é possível conectar-se à fonte de dados. Por favor, verifique se o Flexmonster Accelerator está funcionando.',
          ocsvIncompatible:
            'Não é possível ler a fonte de dados. Parece que o arquivo OCSV foi compactado com uma versão mais nova. Por favor, atualize o componente para a versão {0} ou mais recente.',
          unknownError: 'Ocorreu um erro desconhecido.',
          invalidReportFormat: 'Formato de relatório inválido ou acesso ao arquivo foi negado.',
          invalidReportFormat2: "Invalid report format. 'dataSource' property is required.",
          csvHeaderParsingError: 'Erro de análise do cabeçalho CSV.',
          tooManyColumnsInClassicMode: 'Muitas colunas para forma clássica. Layout comutado para forma compacta.',
          cantExpand: 'Alguns campos não podem ser expandidos. Por favor, reduza o conjunto de dados.',
          cantExpandTitle: 'O conjunto de dados é muito grande',
          selectFile: 'Selecionar arquivo .CSV para carregar',
          flatTableIsNotSupported: 'A tabela simples não é suportada para a origem de dados {0}.',
          enterGroupNamePrompt: 'Por favor, insira o nome do grupo:',
          exportFontLoadingError: 'Failed to load the font. An unexpected error occurred.'
        },
        kpis: {
          kpis: 'KPIs',
          value: 'Valor',
          goal: 'Goal',
          trend: 'Trend',
          status: 'Status'
        },
        buttons: {
          ok: 'OK',
          apply: 'Aplique',
          cancel: 'Cancelar',
          save: 'Salvar',
          clear: 'Limpar',
          select: 'Procurar...',
          yes: 'Sim',
          no: 'Não'
        },
        contextMenu: {
          clearSorting: 'Limpar ordenação',
          collapse: 'Colapso',
          drillThrough: 'Perfurar',
          expand: 'Expandir',
          openFilter: 'Filtro aberto',
          filterBy: 'Filtrar por <b>{0}</b>',
          removeField: 'Remover campo',
          removeMeasure: 'Remover valor',
          sortColumnAsc: 'Ordenar coluna asc',
          sortColumnDesc: 'Ordenar coluna desc',
          sortRowAsc: 'Ordenar linha asc',
          sortRowDesc: 'Ordenar linha desc',
          aggregation: 'Agregação',
          properties: 'Propriedades',
          editFormula: 'Editar <b>{0}</b>',
          moveToRows: 'Mover para linhas',
          moveToColumns: 'Mover para colunas',
          moveToReportFilters: 'Mover para filtros',
          conditionalFormatting: 'Formatação condicional',
          numberFormatting: 'Formatar celulas',
          showProperty: 'Exposição <b>{0}</b>',
          hideProperty: 'Ocultar <b>{0}</b>',
          groupMembers: 'Membros do grupo',
          ungroupMembers: 'Desagrupar membros'
        },
        date: {
          year: 'Ano',
          quarter: 'Trimestre',
          month: 'Mês',
          day: 'Dia'
        },
        quarters: {
          q1: 'T1',
          q2: 'T2',
          q3: 'T3',
          q4: 'T4'
        },
        months: {
          january: 'Janeiro',
          february: 'Fevereiro',
          march: 'Março',
          april: 'Abril',
          may: 'Maio',
          june: 'Junho',
          july: 'Julho',
          august: 'Agosto',
          september: 'Setembro',
          october: 'Outubro',
          november: 'Novembro',
          december: 'Dezembro'
        },
        monthsShort: {
          january: 'Jan',
          february: 'Feb',
          march: 'Mar',
          april: 'Apr',
          may: 'May',
          june: 'Jun',
          july: 'Jul',
          august: 'Aug',
          september: 'Sep',
          october: 'Oct',
          november: 'Nov',
          december: 'Dec'
        },
        weekdays: {
          first: 'Sunday',
          second: 'Monday',
          third: 'Tuesday',
          fourth: 'Wednesday',
          fifth: 'Thursday',
          sixth: 'Friday',
          seventh: 'Saturday'
        },
        weekdaysShort: {
          first: 'Sun',
          second: 'Mon',
          third: 'Tue',
          fourth: 'Wed',
          fifth: 'Thu',
          sixth: 'Fri',
          seventh: 'Sat'
        },
        toolbar: {
          connect: 'Conectar',
          connect_local_csv: 'CSV local',
          connect_local_ocsv: 'OCSV local',
          connect_local_json: 'JSON local',
          connect_remote_csv: 'CSV remoto',
          connect_remote_csv_mobile: 'CSV',
          connect_remote_json: 'JSON remoto',
          connect_remote_json_mobile: 'JSON',
          connect_olap: 'OLAP (XMLA)',
          connect_olap_mobile: 'OLAP',
          connect_elastic: 'Elasticsearch',
          connect_elastic_mobile: 'Elastic',
          open: 'Abrir',
          local_report: 'Relatório local',
          remote_report: 'Relatório remoto',
          remote_report_mobile: 'Relatório',
          save: 'Salvar',
          load_json: 'Relatório JSON',
          grid: 'Tabela',
          grid_flat: 'Plana',
          grid_classic: 'Clássico',
          grid_compact: 'Compactar',
          charts: 'Gráficos',
          charts_column: 'Barras',
          charts_bar_horizontal: 'Barra',
          charts_line: 'Linha',
          charts_scatter: 'Dispersão',
          charts_pie: 'Pizza',
          charts_stacked_column: 'Coluna empilhada',
          charts_column_line: 'Linha de coluna',
          charts_multiple: 'Vários valores',
          charts_multiple_disabled: 'Valores múltiplos não se aplicam a ',
          format: 'Formatar',
          format_cells: 'Formatar celulas',
          format_cells_mobile: 'Formatar',
          conditional_formatting: 'Formatação condicional',
          conditional_formatting_mobile: 'Condicional',
          options: 'Opções',
          fullscreen: 'Tela cheia',
          minimize: 'Minimizar',
          export: 'Exportar',
          export_print: 'Imprimir',
          export_html: 'HTML',
          export_csv: 'CSV',
          export_excel: 'Excel',
          export_image: 'Imagem',
          export_pdf: 'PDF',
          fields: 'Campos',
          ok: 'OK',
          apply: 'Aplique',
          done: 'Feito',
          cancel: 'Cancelar',
          value: 'Valor',
          delete: 'Excluir',
          if: 'E se',
          then: 'Então',
          open_remote_csv: 'Abrir CSV remoto',
          open_remote_json: 'Abrir JSON remoto',
          csv: 'CSV',
          olap_connection_tool: 'Ferramenta de conexão OLAP',
          select_data_source: 'Selecionar fonte de dados',
          select_catalog: 'Selecionar catálogo',
          select_cube: 'Selecionar cubo',
          proxy_url: 'URL de proxy',
          data_source_info: 'Informações sobre fonte de dados',
          catalog: 'Catálogo',
          cube: 'Cubo',
          credentials: 'credenciais',
          username: 'Nome de usuário',
          password: 'Senha',
          connect_elastic_title: 'Conecte-se ao Elasticsearch',
          host_url: 'URL do host',
          index_name: 'Índice',
          select_index: 'Selecione o índice',
          open_remote_report: 'Abrir relatório remoto',
          choose_value: 'Escolha o valor',
          text_align: 'Alinhamento de texto',
          align_left: 'esquerda',
          align_right: 'certo',
          none: 'Nenhum',
          space: '(Espaço)',
          thousand_separator: 'Mil separadores',
          decimal_separator: 'Separador decimal',
          decimal_places: 'Casas decimais',
          currency_symbol: 'Símbolo monetário',
          positive_currency_format: 'Formato monetário positivo',
          negative_currency_format: 'Formato de moeda negativa',
          currency_align: 'Moeda alinhar',
          null_value: 'Valor nulo',
          is_percent: 'Formatar como porcentagem',
          true_value: 'verdade',
          false_value: 'falso',
          confirm_title: 'Você tem algumas alterações não salvas',
          confirm_message: 'Sua formatação não será aplicada. </ br> Por favor, confirme que você quer mudar o valor de qualquer maneira.',
          conditional: 'Condicional',
          less_than: 'Menos que',
          less_than_or_equal: 'Menos que ou igual a',
          greater_than: 'Melhor que',
          greater_than_or_equal: 'Maior ou igual a',
          equal_to: 'Igual a',
          not_equal_to: 'Não é igual a',
          between: 'Entre',
          is_empty: 'Vazio',
          all_values: 'Todos os valores',
          and: 'e',
          and_symbole: '&',
          no_active_conditions: 'Não há condições ativas.',
          add_condition_button: 'Adicionar condição',
          cp_text: 'Texto',
          cp_highlight: 'Realçar',
          layout_options: 'Opções de layout',
          layout: 'Layout',
          compact_view: 'Formulário compacto',
          classic_view: 'Forma clássica',
          flat_view: 'Forma plana',
          grand_totals: 'Totais gerais',
          grand_totals_off: 'Desligado para linhas e colunas',
          grand_totals_on: 'Ativado para linhas e colunas',
          grand_totals_on_rows: 'Ativado somente para linhas',
          grand_totals_on_columns: 'Somente para colunas',
          subtotals: 'Subtotais',
          subtotals_off: 'Não mostrar subtotais',
          subtotals_on: 'Mostrar subtotais',
          subtotals_on_rows: 'Mostrar apenas as linhas de subtotal',
          subtotals_on_columns: 'Mostrar apenas colunas subtotais',
          choose_page_orientation: 'Escolha a orientação da página',
          landscape: 'Paisagem',
          portrait: 'Retrato',
          tooltips: {
            add_condition: 'Adicionar condição',
            remove_condition: 'Remover condição',
            cp_text_color: 'Cor do texto'
          }
        }
      };
    }
  }
};
</script>
<style lang="scss">
.field-i4proFlexmonster {
  * {
    letter-spacing: initial;
  }
}
</style>
